module.exports = __webpack_public_path__ + "img/1717381635431-nib keripik opatan.png.ec3d7be3.webp";